/* @ngInject */
function ProfileController ($scope, $state, $q, $rootScope, BusinessDataService, UdsModalService, $translate, Utils) {
  const getUpgradeCompanyPlanDialogController = () => import('../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  $scope.selectedMenuId = null
  $scope.shouldEnableBusinessData = false
  $scope.userContexts = []
  $scope.professionalDataLabel = ''

  $scope.companyFeatures = {
    placeholderTexts: {
      access: true
    }
  }

  let planName = ''

  const api = {
    getUpgradeCompanyPlanDialogController,
    activate,
    _openUpgradeCompanyPlanDialog,
    _getCompanyFeatures,
    _handleprofessionalDataLabel
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getCompanyFeatures().then(() => {
      const promises = [
        BusinessDataService.getAllBusinessDataService(),
        BusinessDataService.getBusinessDataService()
      ]

      $q.all(promises)
        .then(([businessDataFields, userContexts]) => {
          const userHasFeatureEnabled = $scope.companyFeatures.placeholderTexts.access || $rootScope.isUserSysAdmin()
          const planIsWorkflow = planName.includes('Workflow')

          $scope.shouldEnableBusinessData = Boolean(businessDataFields.length) && userHasFeatureEnabled && !planIsWorkflow
          $scope.userContexts = userContexts
        })
    })
  }

  const deregisterRefreshBusinessData = $rootScope.$on('refresh-business-data', () => {
    api.activate()
  })

  $scope.$on('$destroy', () => {
    deregisterRefreshBusinessData()
  })

  angular.element(document).ready(function () {
    // scroll to start of page
    $(document).scrollTop(0)
  })

  $scope.openItem = (item) => {
    const section = $('#section-businessData-' + item.id)
    if (section.length) {
      $([document.documentElement, document.body]).animate({
        scrollTop: section.offset().top - 300
      }, 800)
    }
  }

  $scope.navigateTo = function (state) {
    $('.sidebar-menu-second-level').transition('slide down')
    $state.go(state)
  }

  $scope.handleBusinessDataClick = (state) => {
    if (!$scope.companyFeatures.placeholderTexts.access) {
      api._openUpgradeCompanyPlanDialog()
    } else {
      $scope.navigateTo(state)
    }
  }

  function _getCompanyFeatures () {
    return $rootScope.getCompanyFeaturesAndAddons().then((plan) => {
      planName = plan.name
      $scope.companyFeatures.placeholderTexts = {
        access: !!plan.features['ARTS.EDITOR_AUTOMATIC_FIELDS']
      }

      return api._handleprofessionalDataLabel()
    })
  }

  function _openUpgradeCompanyPlanDialog () {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName: $translate.instant('billingFeatures.artsEditorAutomaticFields'),
          featureSlug: 'ARTS.EDITOR_AUTOMATIC_FIELDS'
        }
      })
      upgradeCompanyPlanDialog.open()
    })
  }

  function _handleprofessionalDataLabel () {
    const label = $translate.instant('units')
    $scope.professionalDataLabel = $scope.companyFeatures.placeholderTexts.access ? label : Utils.truncateText(label, 11)
  }
}

export { ProfileController }
